import React, { useContext } from 'react';
import { Checkbox, Icon } from 'uxd-design-system-components';
import PropTypes from 'prop-types';
import ValueRowProps from '~types/components/ValueRowProps';
import './ValueRow.scss';
import getText from '../../../assets/locale/locale';
import LocaleContext from '../../../contexts/LocaleContext';
import UserPersonaTypes from '../../../constants/UserPersonaTypes';
import UserContext from '../../../contexts/UserContext';

const ValueRow = (props: ValueRowProps) => {
  const {
    valueStatement,
    valueStatementId,
    disabled,
    setShowAdditionalInfoModal,
    setShowCustomPriorityEditModal,
    isEditable,
    setEditModalCurrentCardValue,
    infoModalContent,
    setInfoModalContent,
  } = props;
  const locId = useContext(LocaleContext);
  const enterKey = 13;
  const escapeKey = 27;
  const personaTypeArrayUS = Array.of(
    UserPersonaTypes.WORD_POWER,
    UserPersonaTypes.NEWS_LETTER,
    UserPersonaTypes.PERSONAL_LINK,
    UserPersonaTypes.PERSONAL_LINK_FA_PROFILE,
    UserPersonaTypes.FINANCIAL_FOUNDATION,
    UserPersonaTypes.DIRECT_URL
  );
  const userPersona = useContext(UserContext);

  const valueAdditionalInfoOnClickHandler = () => {
    if (isEditable) {
      setInfoModalContent(
        getText(locId, 'customPriorityInfoModalTitle', 'customizePage')
      );
    } else {
      setInfoModalContent(infoModalContent);
    }
    setShowAdditionalInfoModal(true);
  };

  const valueAdditionalInfoKeyDownHandler = (
    e: React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (e.keyCode === enterKey) {
      if (isEditable) {
        setInfoModalContent(
          getText(locId, 'customPriorityInfoModalTitle', 'customizePage')
        );
      } else {
        setInfoModalContent(infoModalContent);
      }
      setShowAdditionalInfoModal(true);
    }
    if (e.keyCode === escapeKey) {
      setShowAdditionalInfoModal(false);
    }
  };

  const valueEditOnClickHandler = () => {
    setEditModalCurrentCardValue({
      statementId: valueStatementId,
      statementText: valueStatement,
    });
    setShowCustomPriorityEditModal(true);
  };

  const valueEditKeyDownHandler = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.keyCode === enterKey) {
      setEditModalCurrentCardValue({
        statementId: valueStatementId,
        statementText: valueStatement,
      });
      setShowCustomPriorityEditModal(true);
    }
    if (e.keyCode === escapeKey) {
      setShowCustomPriorityEditModal(false);
    }
  };

  return (
    <div className="value-row" data-testid={`valueRow-${valueStatementId}`}>
      <Checkbox
        checked={!disabled}
        id={`checkbox-${valueStatementId}`}
        name={`checkbox-${valueStatementId}`}
        label={valueStatement}
        hideLabel
        onChange={() => {}}
      />
      {!personaTypeArrayUS.includes(userPersona) &&
      (isEditable || infoModalContent) ? (
        <div
          role="button"
          className="value-additional-info-button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            valueAdditionalInfoOnClickHandler();
          }}
          onKeyDown={(e) => {
            e.stopPropagation();
            valueAdditionalInfoKeyDownHandler(e);
          }}
        >
          <span
            className="value-edit-info--icon--custom-size"
            data-testid={`value-additional-info-button-${valueStatementId}`}
          >
            <Icon name="help-question-mark" />
          </span>
        </div>
      ) : null}
      {isEditable ? (
        <div
          role="button"
          className="value-edit-row-text"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            valueEditOnClickHandler();
          }}
          onKeyDown={(e) => {
            e.stopPropagation();
            valueEditKeyDownHandler(e);
          }}
        >
          {valueStatement}
        </div>
      ) : (
        <div className="value-row-text">{valueStatement}</div>
      )}
    </div>
  );
};

ValueRow.defaultProps = {
  disabled: false,
  setShowAdditionalInfoModal: null,
  setShowCustomPriorityEditModal: null,
  isEditable: false,
  setEditModalCurrentCardValue: null,
  infoModalContent: null,
  setInfoModalContent: null,
};

ValueRow.propTypes = {
  valueStatement: PropTypes.string.isRequired,
  valueStatementId: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  setShowAdditionalInfoModal: PropTypes.func,
  setShowCustomPriorityEditModal: PropTypes.func,
  isEditable: PropTypes.bool,
  setEditModalCurrentCardValue: PropTypes.func,
  infoModalContent: PropTypes.string,
  setInfoModalContent: PropTypes.func,
};

export default ValueRow;
